<mat-expansion-panel
  class="campaign-form-expansion-panel"
  [attr.data-testid]="'campaign-form-section-' + section()"
  [attr.data-expanded]="expanded()"
  [attr.data-submitting]="submitting()"
  [hideToggle]="true"
  [disabled]="disabled()"
  [expanded]="expanded()"
  #expansionPanel
>
  <mat-expansion-panel-header>
    <div class="flex w-full items-center justify-between">
      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          @if (campaignWithCustomerLoading()) {
            <div class="flex items-center justify-center w-6 h-6">
              <ngx-skeleton-loader class="h-5" [theme]="{ width: '20px', height: '20px', 'border-radius': '100vw' }" />
            </div>
          } @else {
            <app-icon
              class="w-6 h-6"
              [src]="sectionCompleted() ? 'icons/circle-check.svg' : 'icons/circle.svg'"
              [color]="sectionCompleted() ? 'var(--shikenso-pink-base)' : 'var(--shikenso-purple-base)'"
            />
          }
          <h3 class="text-2xl font-medium">
            {{ 'pages.campaignForm.sections.' + section() + '.title' | translate }}
          </h3>
        </div>
        <p class="text-sm text-shikenso-purple-base-60 mt-0.5">
          {{ 'pages.campaignForm.sections.' + section() + '.subtitle' | translate }}
        </p>
      </div>

      @if (!expanded()) {
        @if (loading()) {
          <ngx-skeleton-loader class="h-8" [theme]="{ width: '101px', height: '32px', 'border-radius': '100vw' }" />
        } @else {
          <button
            mat-flat-button
            color="secondary"
            class="mat-slim-button"
            [disabled]="submitting()"
            [class.!pointer-events-none]="disabled() || submitting() || loading()"
            (click)="onSectionManageClick($event)"
          >
            {{ 'pages.campaignForm.sections.creatorsAndCtas.manage' | translate }}
          </button>
        }
      } @else {
        <button
          mat-icon-button
          color="secondary-transparent"
          class="mat-big-icon-button"
          [disabled]="submitting()"
          (click)="onSectionCloseClick($event, expansionPanel)"
        >
          <app-icon src="icons/x-mark.svg" class="w-6 h-6" />
        </button>
      }

      @if (expanded()) {
        <hr class="absolute w-full -ml-8 bottom-0 border-shikenso-purple-base-12" />
      }
    </div>
  </mat-expansion-panel-header>

  <div class="flex flex-col gap-6 pt-3">
    <ng-content />

    <div class="flex items-center justify-end gap-3">
      <button
        mat-flat-button
        color="secondary-transparent"
        [disabled]="submitting()"
        (click)="onSectionCloseClick($event, expansionPanel)"
      >
        {{ 'shared.cancel' | translate }}
      </button>

      <div matTooltipPosition="above" [matTooltip]="canSaveDisabledMessage()" [matTooltipDisabled]="canSave()">
        <button
          mat-flat-button
          [disabled]="submitting() || !canSave()"
          (click)="onSectionSaveClick($event, expansionPanel)"
        >
          @if (submitting()) {
            <app-dots-spinner [absoluteCentered]="true" />
          } @else {
            <span [class.hidden]="submitting()">{{ 'shared.form.save' | translate }}</span>
          }
        </button>
      </div>
    </div>
  </div>
</mat-expansion-panel>
